define(function () {

  var initDisclaimer = function(successCallback){
    var disclaimer = $('.modal-disclaimer');
    disclaimer.find('.btn-continue').on('click', function(e){
      e.preventDefault();
      disclaimer.modal('hide');
      disclaimer.addClass('accepted');
      if (successCallback) successCallback();
    });
  };

  var showDisclaimer = function(){
    var disclaimer = $('.modal-disclaimer:not(.accepted)');
    if(disclaimer.length){
      disclaimer.modal('show');
      return true;
    }
    return false;
  };

  return {
    initDisclaimer: initDisclaimer,
    showDisclaimer: showDisclaimer
  };
});
